function initBuyAgain() {
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".order-row").forEach(function (row) {
      row.addEventListener("click", function (e) {
        // Ignore clicks on interactive elements like buttons
        if (e.target.closest("button, a, .js-buy-again")) return;
        window.location = row.dataset.href;
      });
    });
  });

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-buy-again");
    if (!btn) return;

    e.stopPropagation();

    const items = JSON.parse(btn.dataset.lineItems);

    try {
      // Add all items in ONE request
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        throw new Error("Failed to add items");
      }

      await res.json();

      // Open cart and refresh once
      window.CartDrawer.open();
      await window.CartDrawer.refresh();
      document.dispatchEvent(
        new CustomEvent("cart:itemAdded", { detail: { items } }),
      );
    } catch (err) {
      console.error("Buy again failed:", err);
      alert("Some items could not be added to your cart.");
    }
  });
}

initBuyAgain();

export { initBuyAgain };
